import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f3ea1da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body p-9" }
const _hoisted_2 = { class: "row mb-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, " URL Berita ", -1))
const _hoisted_4 = { class: "col-10 fv-row" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-10" }
const _hoisted_7 = { class: "input-group mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text text-muted" }, " https://twitter.com/ID_Akun/status/ ", -1))
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<small class=\"d-flex align-items-center\" data-v-7f3ea1da><i class=\"bi bi-info-circle me-1\" data-v-7f3ea1da></i><span class=\"text-muted\" data-v-7f3ea1da> Masukkan hanya ID berita dari URL </span></small><small class=\"d-flex align-items-center\" data-v-7f3ea1da><i class=\"bi bi-info-circle me-1\" data-v-7f3ea1da></i><span class=\"text-muted\" data-v-7f3ea1da> ID berita merupakan string bagian terakhir setelah URL &quot;https://twitter.com/ID_Akun/status/&quot; </span></small>", 2)
const _hoisted_11 = { class: "col-md-2 pull-right" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Ambil Data ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = {
  key: 0,
  class: "col-2"
}
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = {
  key: 0,
  class: "alert alert-primary"
}
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = ["name", "onUpdate:modelValue", "disabled"]
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = ["name", "onUpdate:modelValue", "disabled"]
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = ["name", "onUpdate:modelValue", "disabled"]
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { class: "row mb-6" }
const _hoisted_35 = ["name", "onUpdate:modelValue", "disabled"]
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "row mb-6" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tanggal Berita", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-1 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Tanggal dalam GMT+7"
}, null, -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "row mb-6" }
const _hoisted_45 = ["name", "onUpdate:modelValue", "disabled"]
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = { class: "row mb-6" }
const _hoisted_49 = ["name", "onUpdate:modelValue", "disabled"]
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = ["name", "onUpdate:modelValue", "disabled"]
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "row mb-6" }
const _hoisted_57 = ["name", "onUpdate:modelValue", "disabled"]
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "row mb-6" }
const _hoisted_61 = ["name", "onUpdate:modelValue", "disabled"]
const _hoisted_62 = { class: "fv-plugins-message-container" }
const _hoisted_63 = { class: "fv-help-block" }
const _hoisted_64 = { class: "row mb-6" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "d-block fw-bold text-start" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "d-block fw-bold text-start" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "d-block fw-bold text-start" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "d-block fw-bold text-start" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = { class: "d-block fw-bold text-start" }
const _hoisted_76 = { class: "fv-plugins-message-container" }
const _hoisted_77 = { class: "fv-help-block" }
const _hoisted_78 = { class: "row mb-6" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "d-block fw-bold text-start" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { class: "d-block fw-bold text-start" }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = { class: "d-block fw-bold text-start" }
const _hoisted_86 = { class: "fv-plugins-message-container" }
const _hoisted_87 = { class: "fv-help-block" }
const _hoisted_88 = { class: "row mb-6" }
const _hoisted_89 = ["name", "onUpdate:modelValue"]
const _hoisted_90 = ["onClick"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-align-justify text-white" }, null, -1))
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" Fix OCR Text ")
const _hoisted_93 = [
  _hoisted_91,
  _hoisted_92
]
const _hoisted_94 = { class: "fv-plugins-message-container" }
const _hoisted_95 = { class: "fv-help-block" }
const _hoisted_96 = {
  key: 0,
  class: "row"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1))
const _hoisted_98 = { class: "col-10" }
const _hoisted_99 = { class: "card-footer d-flex py-6" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  class: "btn btn-sm btn-warning me-auto",
  style: {"margin-left":"-1rem"}
}, " Reset Data ", -1))
const _hoisted_101 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitTwitter",
  class: "btn btn-sm btn-success"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan Data ", -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Menyimpan Data... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_104 = [
  _hoisted_102,
  _hoisted_103
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("form", {
    id: "kt_account_profile_details_form",
    class: "form",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.saveMedsos()), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "url",
                  class: "form-control form-control-lg",
                  placeholder: "ID URL Berita",
                  modelValue: _ctx.ids,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ids) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-lg btn-block",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getContentUrl && _ctx.getContentUrl(...args))),
                ref: "getDataButton1",
                disabled: _ctx.ids == ''
              }, _hoisted_15, 8, _hoisted_12)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_ErrorMessage, { name: "url" })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_ctx.MediaSosialForm.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.MediaSosialForm.length > 1 ? 'col-10' : 'col-12')
        }, [
          (_ctx.MediaSosialForm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MediaSosialForm, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["mb-5", _ctx.MediaSosialForm.length > 1 ? 'col-6' : 'col-12']),
                    key: index
                  }, [
                    (_ctx.MediaSosialForm.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("strong", null, "#DATA KE - " + _toDisplayString(index + 1), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["required fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, " Akun ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          required: "",
                          type: "text",
                          name: 'title' + index,
                          class: "form-control form-control-lg",
                          placeholder: "Akun",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.MediaSosialForm[index].account) = $event),
                          disabled: _ctx.isEnableField
                        }, null, 8, _hoisted_23), [
                          [_vModelText, _ctx.MediaSosialForm[index].account]
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'title' + index
                            }, null, 8, ["name"])
                          ])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["required fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, " Nama Akun ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          required: "",
                          type: "text",
                          name: 'account' + index,
                          class: "form-control form-control-lg",
                          placeholder: "Nama Akun",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.MediaSosialForm[index].account_name) = $event),
                          disabled: _ctx.isEnableField
                        }, null, 8, _hoisted_27), [
                          [_vModelText, _ctx.MediaSosialForm[index].account_name]
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'account' + index
                            }, null, 8, ["name"])
                          ])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["required fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, " URL Akun ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          required: "",
                          type: "text",
                          name: 'url_account' + index,
                          class: "form-control form-control-lg",
                          placeholder: "URL Akun",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.MediaSosialForm[index].id_account) = $event),
                          disabled: _ctx.isEnableField
                        }, null, 8, _hoisted_31), [
                          [_vModelText, _ctx.MediaSosialForm[index].id_account]
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'url_account' + index
                            }, null, 8, ["name"])
                          ])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["required fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, " URL Berita ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          required: "",
                          type: "text",
                          name: 'url_berita' + index,
                          class: "form-control form-control-lg",
                          placeholder: "URL Berita",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.MediaSosialForm[index].url) = $event),
                          disabled: _ctx.isEnableField
                        }, null, 8, _hoisted_35), [
                          [_vModelText, _ctx.MediaSosialForm[index].url]
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'url_berita' + index
                            }, null, 8, ["name"])
                          ])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, _hoisted_41, 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _createVNode(_component_Field, { name: "date" }, {
                          default: _withCtx(({ handleBlur, handleChange }) => [
                            _createVNode(_component_el_form, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  prop: "dueDate",
                                  class: "mb-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_date_picker, {
                                      style: {"width":"100% !important"},
                                      onBlur: handleBlur,
                                      onChange: handleChange,
                                      clearable: false,
                                      modelValue: _ctx.MediaSosialForm[index].date,
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.MediaSosialForm[index].date) = $event),
                                      placeholder: "Tanggal Berita",
                                      format: "YYYY-MM-DD HH:mm:ss",
                                      name: 'date' + index,
                                      type: "datetime",
                                      disabled: _ctx.isEnableField
                                    }, null, 8, ["onBlur", "onChange", "modelValue", "onUpdate:modelValue", "name", "disabled"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'date' + index
                            }, null, 8, ["name"])
                          ])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["required fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, " Jumlah Favorite ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          required: "",
                          type: "number",
                          name: 'engagement_detail_like' + index,
                          class: "form-control form-control-lg",
                          placeholder: "Jumlah Favorite",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.MediaSosialForm[index].engagement_detail.fav) = $event),
                          disabled: _ctx.isEnableField
                        }, null, 8, _hoisted_45), [
                          [_vModelText, _ctx.MediaSosialForm[index].engagement_detail.fav]
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'engagement_detail_like' + index
                            }, null, 8, ["name"])
                          ])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["required fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, " Jumlah Quote ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          required: "",
                          type: "number",
                          name: 'engagement_detail_comment' + index,
                          class: "form-control form-control-lg",
                          placeholder: "Jumlah Quote",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.MediaSosialForm[index].engagement_detail.quote) = $event),
                          disabled: _ctx.isEnableField
                        }, null, 8, _hoisted_49), [
                          [_vModelText, _ctx.MediaSosialForm[index].engagement_detail.quote]
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'engagement_detail_comment' + index
                            }, null, 8, ["name"])
                          ])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["required fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, " Jumlah Reply ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          required: "",
                          type: "number",
                          name: 'engagement_detail_viewer' + index,
                          class: "form-control form-control-lg",
                          placeholder: "Jumlah Reply",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.MediaSosialForm[index].engagement_detail.reply) = $event),
                          disabled: _ctx.isEnableField
                        }, null, 8, _hoisted_53), [
                          [_vModelText, _ctx.MediaSosialForm[index].engagement_detail.reply]
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'engagement_detail_viewer' + index
                            }, null, 8, ["name"])
                          ])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["required fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, " Jumlah Retweet ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          required: "",
                          type: "number",
                          name: 'engagement_detail_favorite' + index,
                          class: "form-control form-control-lg",
                          placeholder: "Jumlah Retweet",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.MediaSosialForm[index].engagement_detail.rt) = $event),
                          disabled: _ctx.isEnableField
                        }, null, 8, _hoisted_57), [
                          [_vModelText, _ctx.MediaSosialForm[index].engagement_detail.rt]
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'engagement_detail_favorite' + index
                            }, null, 8, ["name"])
                          ])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["required fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, " Jumlah Follower ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          required: "",
                          type: "number",
                          name: 'followers' + index,
                          class: "form-control form-control-lg",
                          placeholder: "Jumlah Follower",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.MediaSosialForm[index].followers) = $event),
                          disabled: _ctx.isEnableField
                        }, null, 8, _hoisted_61), [
                          [_vModelText, _ctx.MediaSosialForm[index].followers]
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'followers' + index
                            }, null, 8, ["name"])
                          ])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, " Emotion ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.MediaSosialForm.length > 1 ? 'col-auto' : 'col-2')
                          }, [
                            _createVNode(_component_Field, {
                              class: "btn-check",
                              name: 'emotion' + index,
                              id: 'emotion_netral' + index
                            }, null, 8, ["name", "id"]),
                            _createElementVNode("label", {
                              class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default d-flex align-items-center", 
                          _ctx.MediaSosialForm[index].emotion == '0'
                            ? _ctx.MediaSosialForm.length > 1
                              ? 'px-2 cek-active'
                              : 'p-2 cek-active'
                            : _ctx.MediaSosialForm.length > 1
                            ? 'px-2'
                            : 'p-2'
                        ]),
                              onClick: ($event: any) => (_ctx.setEmotion(index, '0')),
                              for: "emotion_netral"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["svg-icon svg-icon-3x", _ctx.MediaSosialForm.length > 1 ? '' : 'me-5'])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["far fa-meh-blank text-primary", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-sm' : 'fs-2x'
                            ])
                                }, null, 2)
                              ], 2),
                              _createElementVNode("span", _hoisted_67, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-gray-400 fw-bold", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-8' : 'fs-6'
                            ])
                                }, " Netral ", 2)
                              ])
                            ], 10, _hoisted_66)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.MediaSosialForm.length > 1 ? 'col-auto' : 'col-2')
                          }, [
                            _createVNode(_component_Field, {
                              class: "btn-check",
                              name: 'emotion' + index,
                              id: 'emotion_senang' + index
                            }, null, 8, ["name", "id"]),
                            _createElementVNode("label", {
                              class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default d-flex align-items-center", 
                          _ctx.MediaSosialForm[index].emotion == '1'
                            ? _ctx.MediaSosialForm.length > 1
                              ? 'px-2 cek-active'
                              : 'p-2 cek-active'
                            : _ctx.MediaSosialForm.length > 1
                            ? 'px-2'
                            : 'p-2'
                        ]),
                              onClick: ($event: any) => (_ctx.setEmotion(index, '1')),
                              for: "emotion_senang"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["svg-icon svg-icon-3x", _ctx.MediaSosialForm.length > 1 ? '' : 'me-5'])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["far fa-grin-squint text-success", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-sm' : 'fs-2x'
                            ])
                                }, null, 2)
                              ], 2),
                              _createElementVNode("span", _hoisted_69, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-gray-400 fw-bold", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-8' : 'fs-6'
                            ])
                                }, " Senang ", 2)
                              ])
                            ], 10, _hoisted_68)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.MediaSosialForm.length > 1 ? 'col-auto' : 'col-2')
                          }, [
                            _createVNode(_component_Field, {
                              class: "btn-check",
                              name: 'emotion' + index,
                              id: 'emotion_takut' + index
                            }, null, 8, ["name", "id"]),
                            _createElementVNode("label", {
                              class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default d-flex align-items-center", 
                          _ctx.MediaSosialForm[index].emotion == '2'
                            ? _ctx.MediaSosialForm.length > 1
                              ? 'px-2 cek-active'
                              : 'p-2 cek-active'
                            : _ctx.MediaSosialForm.length > 1
                            ? 'px-2'
                            : 'p-2'
                        ]),
                              onClick: ($event: any) => (_ctx.setEmotion(index, '2')),
                              for: "emotion_takut"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["svg-icon svg-icon-3x", _ctx.MediaSosialForm.length > 1 ? '' : 'me-5'])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["far fa-flushed text-warning", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-sm' : 'fs-2x'
                            ])
                                }, null, 2)
                              ], 2),
                              _createElementVNode("span", _hoisted_71, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-gray-400 fw-bold", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-8' : 'fs-6'
                            ])
                                }, " Takut ", 2)
                              ])
                            ], 10, _hoisted_70)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.MediaSosialForm.length > 1 ? 'col-auto' : 'col-2')
                          }, [
                            _createVNode(_component_Field, {
                              class: "btn-check",
                              name: 'emotion' + index,
                              id: 'emotion_sedih' + index
                            }, null, 8, ["name", "id"]),
                            _createElementVNode("label", {
                              class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default d-flex align-items-center", 
                          _ctx.MediaSosialForm[index].emotion == '3'
                            ? _ctx.MediaSosialForm.length > 1
                              ? 'px-2 cek-active'
                              : 'p-2 cek-active'
                            : _ctx.MediaSosialForm.length > 1
                            ? 'px-2'
                            : 'p-2'
                        ]),
                              onClick: ($event: any) => (_ctx.setEmotion(index, '3')),
                              for: "emotion_sedih"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["svg-icon svg-icon-3x", _ctx.MediaSosialForm.length > 1 ? '' : 'me-5'])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["far fa-sad-tear text-complete", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-sm' : 'fs-2x'
                            ])
                                }, null, 2)
                              ], 2),
                              _createElementVNode("span", _hoisted_73, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-gray-400 fw-bold", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-8' : 'fs-6'
                            ])
                                }, " Sedih ", 2)
                              ])
                            ], 10, _hoisted_72)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.MediaSosialForm.length > 1 ? 'col-auto' : 'col-2')
                          }, [
                            _createVNode(_component_Field, {
                              class: "btn-check",
                              name: 'emotion' + index,
                              id: 'emotion_marah' + index
                            }, null, 8, ["name", "id"]),
                            _createElementVNode("label", {
                              class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default d-flex align-items-center", 
                          _ctx.MediaSosialForm[index].emotion == '4'
                            ? _ctx.MediaSosialForm.length > 1
                              ? 'px-2 cek-active'
                              : 'p-2 cek-active'
                            : _ctx.MediaSosialForm.length > 1
                            ? 'px-2'
                            : 'p-2'
                        ]),
                              onClick: ($event: any) => (_ctx.setEmotion(index, '4')),
                              for: "emotion_marah"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["svg-icon svg-icon-3x", _ctx.MediaSosialForm.length > 1 ? '' : 'me-5'])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["far fa-angry text-danger", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-sm' : 'fs-2x'
                            ])
                                }, null, 2)
                              ], 2),
                              _createElementVNode("span", _hoisted_75, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-gray-400 fw-bold", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-8' : 'fs-6'
                            ])
                                }, " Marah ", 2)
                              ])
                            ], 10, _hoisted_74)
                          ], 2),
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                              _createVNode(_component_ErrorMessage, { name: "emotion" })
                            ])
                          ])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, " Sentimen ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.MediaSosialForm.length > 1 ? 'col-auto' : 'col-2')
                          }, [
                            _createVNode(_component_Field, {
                              class: "btn-check",
                              name: 'sentiment' + index,
                              id: 'sentiment_positif' + index
                            }, null, 8, ["name", "id"]),
                            _createElementVNode("label", {
                              class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default d-flex align-items-center", 
                          _ctx.MediaSosialForm[index].sentiment == '1'
                            ? _ctx.MediaSosialForm.length > 1
                              ? 'px-2 cek-active'
                              : 'p-2 cek-active'
                            : _ctx.MediaSosialForm.length > 1
                            ? 'px-2'
                            : 'p-2'
                        ]),
                              onClick: ($event: any) => (_ctx.setSentiment(index, '1')),
                              for: "sentiment_positif"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["svg-icon svg-icon-3x", _ctx.MediaSosialForm.length > 1 ? '' : 'me-5'])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["far fa-smile text-success", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-sm' : 'fs-2x'
                            ])
                                }, null, 2)
                              ], 2),
                              _createElementVNode("span", _hoisted_81, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-gray-400 fw-bold", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-8' : 'fs-6'
                            ])
                                }, " Positif ", 2)
                              ])
                            ], 10, _hoisted_80)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.MediaSosialForm.length > 1 ? 'col-auto' : 'col-2')
                          }, [
                            _createVNode(_component_Field, {
                              class: "btn-check",
                              name: 'sentiment' + index,
                              id: 'sentiment_netral' + index
                            }, null, 8, ["name", "id"]),
                            _createElementVNode("label", {
                              class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default d-flex align-items-center", 
                          _ctx.MediaSosialForm[index].sentiment == '0'
                            ? _ctx.MediaSosialForm.length > 1
                              ? 'px-2 cek-active'
                              : 'p-2 cek-active'
                            : _ctx.MediaSosialForm.length > 1
                            ? 'px-2'
                            : 'p-2'
                        ]),
                              onClick: ($event: any) => (_ctx.setSentiment(index, '0')),
                              for: "sentiment_netral"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["svg-icon svg-icon-3x", _ctx.MediaSosialForm.length > 1 ? '' : 'me-5'])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["far fa-meh text-primary", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-sm' : 'fs-2x'
                            ])
                                }, null, 2)
                              ], 2),
                              _createElementVNode("span", _hoisted_83, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-gray-400 fw-bold", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-8' : 'fs-6'
                            ])
                                }, " Netral ", 2)
                              ])
                            ], 10, _hoisted_82)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.MediaSosialForm.length > 1 ? 'col-auto' : 'col-2')
                          }, [
                            _createVNode(_component_Field, {
                              class: "btn-check",
                              name: 'sentiment' + index,
                              id: 'sentiment_negatif' + index
                            }, null, 8, ["name", "id"]),
                            _createElementVNode("label", {
                              class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default d-flex align-items-center", 
                          _ctx.MediaSosialForm[index].sentiment == '-1'
                            ? _ctx.MediaSosialForm.length > 1
                              ? 'px-2 cek-active'
                              : 'p-2 cek-active'
                            : _ctx.MediaSosialForm.length > 1
                            ? 'px-2'
                            : 'p-2'
                        ]),
                              onClick: ($event: any) => (_ctx.setSentiment(index, '-1')),
                              for: "sentiment_negatif"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["svg-icon svg-icon-3x", _ctx.MediaSosialForm.length > 1 ? '' : 'me-5'])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["far fa-frown text-danger", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-sm' : 'fs-2x'
                            ])
                                }, null, 2)
                              ], 2),
                              _createElementVNode("span", _hoisted_85, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-gray-400 fw-bold", 
                              _ctx.MediaSosialForm.length > 1 ? 'fs-8' : 'fs-6'
                            ])
                                }, " Negatif ", 2)
                              ])
                            ], 10, _hoisted_84)
                          ], 2),
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("div", _hoisted_87, [
                              _createVNode(_component_ErrorMessage, { name: "sentiment" })
                            ])
                          ])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["required fw-bold fs-6", 
                    _ctx.MediaSosialForm.length > 1 ? '' : 'col-2 col-form-label'
                  ])
                      }, " Konten Berita ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row", _ctx.MediaSosialForm.length > 1 ? '' : 'col-10'])
                      }, [
                        _withDirectives(_createElementVNode("textarea", {
                          name: 'content' + index,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.MediaSosialForm[index].content) = $event),
                          type: "textarea",
                          class: "form-control",
                          rows: "10",
                          required: ""
                        }, null, 8, _hoisted_89), [
                          [_vModelText, _ctx.MediaSosialForm[index].content]
                        ]),
                        _createElementVNode("a", {
                          size: "small",
                          class: "btn btn-sm btn-primary mt-5",
                          type: "primary",
                          onClick: ($event: any) => (_ctx.convertText(index))
                        }, _hoisted_93, 8, _hoisted_90),
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'content' + index
                            }, null, 8, ["name"])
                          ])
                        ])
                      ], 2)
                    ])
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    (!_ctx.isEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
          _hoisted_97,
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("div", _hoisted_99, [
              _hoisted_100,
              _createElementVNode("button", _hoisted_101, _hoisted_104, 512)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 32))
}